import Cookie from 'js-cookie';

import { serialize } from 'cookie';
import {
  getCookieDataItem,
  parseCookieLocaleValue,
  checkMaxEntriesInObject
} from '@tools/cookieUtilities';

export const defaultLocale = 'en-US';
const defaultLocaleImport = import('./en-US.json');
export const COOKIE_LOCALE_NAME = 'cvt_cookielocale';

// Create async function that merges multiple import('path-to-locale') results together
export const resolveLocales = localeImports => async () => {
  const resolvedImports = await Promise.all([
    defaultLocaleImport,
    ...localeImports()
  ]);
  return resolvedImports.reduce((acc, value) => {
    const mergedImports = { ...acc, ...value };
    return {
      mergedImports,
      default: {
        ...acc.default,
        ...value.default
      }
    };
  }, {});
};

const locales = {
  'en-US': resolveLocales(() => [
    defaultLocaleImport,
    import('./gamificationShared/en-US.json'),
    import('./timezones/en-US.json'),
    import('./cookieConsentBanner/en-US.json')
  ]),
  'fr-FR': resolveLocales(() => [
    import('./fr-FR.json'),
    import('./gamificationShared/fr-FR.json'),
    import('./timezones/fr-FR.json'),
    import('./cookieConsentBanner/fr-FR.json')
  ]),
  'bg-BG': resolveLocales(() => [
    import('./bg-BG.json'),
    import('./gamificationShared/bg-BG.json'),
    import('./timezones/bg-BG.json'),
    import('./cookieConsentBanner/bg-BG.json')
  ]),
  'cs-CZ': resolveLocales(() => [
    import('./cs-CZ.json'),
    import('./gamificationShared/cs-CZ.json'),
    // import('./timezones/cs-CZ.json')
    import('./cookieConsentBanner/cs-CZ.json')
  ]),
  'da-DK': resolveLocales(() => [
    import('./da-DK.json'),
    import('./gamificationShared/da-DK.json'),
    import('./timezones/da-DK.json'),
    import('./cookieConsentBanner/da-DK.json')
  ]),
  'de-DE': resolveLocales(() => [
    import('./de-DE.json'),
    import('./gamificationShared/de-DE.json'),
    import('./timezones/de-DE.json'),
    import('./cookieConsentBanner/de-DE.json')
  ]),
  'el-GR': resolveLocales(() => [
    import('./el-GR.json'),
    import('./gamificationShared/el-GR.json'),
    import('./timezones/el-GR.json'),
    import('./cookieConsentBanner/el-GR.json')
  ]),
  'es-ES': resolveLocales(() => [
    import('./es-ES.json'),
    import('./gamificationShared/es-ES.json'),
    import('./timezones/es-ES.json'),
    import('./cookieConsentBanner/es-ES.json')
  ]),
  'fi-FI': resolveLocales(() => [
    import('./fi-FI.json'),
    import('./gamificationShared/fi-FI.json'),
    import('./timezones/fi-FI.json'),
    import('./cookieConsentBanner/fi-FI.json')
  ]),
  'fr-CA': resolveLocales(() => [
    import('./fr-CA.json'),
    import('./gamificationShared/fr-CA.json'),
    import('./timezones/fr-CA.json'),
    import('./cookieConsentBanner/fr-CA.json')
  ]),
  'hr-HR': resolveLocales(() => [
    import('./hr-HR.json'),
    import('./gamificationShared/hr-HR.json'),
    // import('./timezones/hr-HR.json')
    import('./cookieConsentBanner/hr-HR.json')
  ]),
  'hu-HU': resolveLocales(() => [
    import('./hu-HU.json'),
    import('./gamificationShared/hu-HU.json'),
    // import('./timezones/hu-HU.json')
    import('./cookieConsentBanner/hu-HU.json')
  ]),
  'it-IT': resolveLocales(() => [
    import('./it-IT.json'),
    import('./gamificationShared/it-IT.json'),
    import('./timezones/it-IT.json'),
    import('./cookieConsentBanner/it-IT.json')
  ]),
  'ja-JP': resolveLocales(() => [
    import('./ja-JP.json'),
    import('./gamificationShared/ja-JP.json'),
    import('./timezones/ja-JP.json'),
    import('./cookieConsentBanner/ja-JP.json')
  ]),
  'ko-KR': resolveLocales(() => [
    import('./ko-KR.json'),
    import('./gamificationShared/ko-KR.json'),
    import('./timezones/ko-KR.json'),
    import('./cookieConsentBanner/ko-KR.json')
  ]),
  'nb-NO': resolveLocales(() => [
    import('./nb-NO.json'),
    import('./gamificationShared/nb-NO.json'),
    import('./timezones/nb-NO.json'),
    import('./cookieConsentBanner/nb-NO.json')
  ]),
  'nl-NL': resolveLocales(() => [
    import('./nl-NL.json'),
    import('./gamificationShared/nl-NL.json'),
    import('./timezones/nl-NL.json'),
    import('./cookieConsentBanner/nl-NL.json')
  ]),
  'pl-PL': resolveLocales(() => [
    import('./pl-PL.json'),
    import('./gamificationShared/pl-PL.json'),
    import('./timezones/pl-PL.json'),
    import('./cookieConsentBanner/pl-PL.json')
  ]),
  'pt-BR': resolveLocales(() => [
    import('./pt-BR.json'),
    import('./gamificationShared/pt-BR.json'),
    import('./timezones/pt-BR.json'),
    import('./cookieConsentBanner/pt-BR.json')
  ]),
  'pt-PT': resolveLocales(() => [
    import('./pt-PT.json'),
    import('./gamificationShared/pt-PT.json'),
    import('./timezones/pt-PT.json'),
    import('./cookieConsentBanner/pt-PT.json')
  ]),
  'ro-RO': resolveLocales(() => [
    import('./ro-RO.json'),
    import('./gamificationShared/ro-RO.json'),
    import('./timezones/ro-RO.json'),
    import('./cookieConsentBanner/ro-RO.json')
  ]),
  'ru-RU': resolveLocales(() => [
    import('./ru-RU.json'),
    import('./gamificationShared/ru-RU.json'),
    import('./timezones/ru-RU.json'),
    import('./cookieConsentBanner/ru-RU.json')
  ]),
  'sk-SK': resolveLocales(() => [
    import('./sk-SK.json'),
    import('./gamificationShared/sk-SK.json'),
    // import('./timezones/sk-SK.json')
    import('./cookieConsentBanner/sk-SK.json')
  ]),
  'sl-SI': resolveLocales(() => [
    import('./sl-SI.json'),
    import('./gamificationShared/sl-SI.json'),
    // import('./timezones/sl-SI.json')
    import('./cookieConsentBanner/sl-SI.json')
  ]),
  'sr-RS': resolveLocales(() => [
    import('./sr-RS.json'),
    import('./gamificationShared/sr-RS.json'),
    // import('./timezones/sr-RS.json')
    import('./cookieConsentBanner/sr-RS.json')
  ]),
  'sv-SE': resolveLocales(() => [
    import('./sv-SE.json'),
    import('./gamificationShared/sv-SE.json'),
    import('./timezones/sv-SE.json'),
    import('./cookieConsentBanner/sv-SE.json')
  ]),
  'th-TH': resolveLocales(() => [
    import('./th-TH.json'),
    import('./gamificationShared/th-TH.json'),
    import('./timezones/th-TH.json'),
    import('./cookieConsentBanner/th-Th.json')
  ]),
  'tr-TR': resolveLocales(() => [
    import('./tr-TR.json'),
    import('./gamificationShared/tr-TR.json'),
    import('./timezones/tr-TR.json'),
    import('./cookieConsentBanner/tr-TR.json')
  ]),
  'uk-UA': resolveLocales(() => [
    import('./uk-UA.json'),
    import('./gamificationShared/uk-UA.json'),
    // import('./timezones/uk-UA.json')
    import('./cookieConsentBanner/uk-UA.json')
  ]),
  'vi-VN': resolveLocales(() => [
    import('./vi-VN.json'),
    import('./gamificationShared/vi-VN.json'),
    import('./timezones/vi-VN.json'),
    import('./cookieConsentBanner/vi-VN.json')
  ]),
  'zh-Hans': resolveLocales(() => [
    import('./zh-Hans.json'),
    import('./gamificationShared/zh-Hans.json'),
    import('./timezones/zh-Hans.json'),
    import('./cookieConsentBanner/zh-Hans.json')
  ]),
  'zh-Hant': resolveLocales(() => [
    import('./zh-Hant.json'),
    import('./gamificationShared/zh-Hant.json'),
    import('./timezones/zh-Hant.json'),
    import('./cookieConsentBanner/zh-Hant.json')
  ]),
  'zh-CN': resolveLocales(() => [
    import('./zh-Hans.json'),
    import('./gamificationShared/zh-Hans.json'),
    import('./timezones/zh-Hans.json'),
    import('./cookieConsentBanner/zh-Hans.json')
  ]),
  'zh-CHT': resolveLocales(() => [
    import('./zh-Hant.json'),
    import('./gamificationShared/zh-Hant.json'),
    import('./timezones/zh-Hant.json'),
    import('./cookieConsentBanner/zh-Hant.json')
  ])
};

// Support regionless languages ("fr" vs "fr-CA")
export const defaultLocales = {
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
  ko: 'ko-KR',
  nl: 'nl-NL',
  pt: 'pt-PT',
  ru: 'ru-RU',
  zh: 'zh-Hans',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant'
};

export const supportedLocales = [
  ...Object.keys(locales),
  ...Object.keys(defaultLocales)
];

const cookieOptions = {
  expires: 365
};

// Override default encoding and decoding function to make similar with server side cookie encoding
const Cookies = Cookie.withConverter({
  write(value) {
    return encodeURIComponent(value);
  },
  read(value) {
    return decodeURIComponent(value);
  }
});

export const getCultureCode = localeInfo => {
  const cultureCode = !localeInfo?.cultureCode
    ? []
    : localeInfo?.cultureCode.split('-');

  if (cultureCode.length === 2) {
    return cultureCode[1];
  }
  if (cultureCode.length === 1) {
    return cultureCode[0];
  }
  return null;
};

/**
 * @description Used to check and return if locale cookie is already set for event
 * @param {Object} ctxCookies
 * @param {string} eventId
 * @returns string
 */
export function checkAndReturnEventIdLocale(ctxCookies, eventId) {
  const cookieValue = ctxCookies[COOKIE_LOCALE_NAME];
  const hasAcceptedEventLocale = getCookieDataItem(
    COOKIE_LOCALE_NAME,
    cookieValue,
    eventId
  );
  return hasAcceptedEventLocale && hasAcceptedEventLocale[eventId];
}

/**
 * @description Used to create  object( [eventId]: locale} ) or overwrite existing locale of a event.
 * @param {Array} cookieValue
 * @param {string} eventId
 * @param {string} locale
 * @returns Array
 */
export function getLocaleByEventIdsCookie(cookieValue, eventId, locale) {
  // Handle Case when acceptedEventIdsLocale is null, empty object, any object or empty object.
  const acceptedEventIdsLocale = parseCookieLocaleValue(
    COOKIE_LOCALE_NAME,
    cookieValue
  );
  if (
    !acceptedEventIdsLocale ||
    !Object.keys(acceptedEventIdsLocale).length ||
    Object.keys(acceptedEventIdsLocale)?.length === 0
  ) {
    return { [eventId]: locale };
  }
  let eventIdPresentInCookie = false;
  const acceptedEventIdsLocaleArray = Object.keys(
    acceptedEventIdsLocale
  ).reduce((result, eventIdKey) => {
    let resultResp = result;
    if (eventIdKey === eventId) {
      eventIdPresentInCookie = true;
      resultResp[eventIdKey] = locale;
    } else if (eventIdKey && acceptedEventIdsLocale[eventIdKey]) {
      resultResp = {
        ...result,
        [eventIdKey]: acceptedEventIdsLocale[eventIdKey]
      };
    }
    return resultResp;
  }, {});
  if (eventIdPresentInCookie) return acceptedEventIdsLocaleArray;
  return checkMaxEntriesInObject(
    acceptedEventIdsLocaleArray,
    { [eventId]: locale },
    5
  );
}

/**
 * @description Used to serialize cookie at server side.
 * @param {string} localeCookieValue
 * @param {string} eventId
 * @param {string} locale
 * @returns string
 */
export const getEventLocaleCookieWithExpirationTime = (
  localeCookieValue,
  eventId,
  locale
) => {
  const localeByEventIds = getLocaleByEventIdsCookie(
    localeCookieValue,
    eventId,
    locale
  );
  return serialize(COOKIE_LOCALE_NAME, JSON.stringify(localeByEventIds), {
    path: '/',
    maxAge: new Date(new Date() * 1 + 365 * 864e5),
    encode: encodeURIComponent
  });
};

/**
 * @description Used to remove eventId from locale cookie at client side / browser
 * @param {string} cookieValue
 * @param {string} eventId
 */
export function removeEventIdFromLocaleCookie(acceptedEventIdsLocale, eventId) {
  const acceptedEventIdsLocaleObject = { ...acceptedEventIdsLocale };
  delete acceptedEventIdsLocaleObject[eventId];
  return Object.keys(acceptedEventIdsLocaleObject).length > 0
    ? acceptedEventIdsLocaleObject
    : null;
}

/**
 * @description Used to set cookie at client side / browser
 * @param {string} eventId
 * @param {string} setLocale
 * @param {string} selectedLocale
 * @param {boolean} isDefaultLocale = false
 */
export const setLocaleCookie = (
  eventId,
  setLocale,
  selectedLocale,
  isDefaultLocale = false
) => {
  if (eventId) {
    // cookie will always be set in the default language coming from the language dropdown
    setLocale(selectedLocale);
    let eventIdsLocaleCookie = getLocaleByEventIdsCookie(
      Cookies.get(COOKIE_LOCALE_NAME),
      eventId,
      selectedLocale
    );
    if (isDefaultLocale) {
      eventIdsLocaleCookie = removeEventIdFromLocaleCookie(
        eventIdsLocaleCookie,
        eventId
      );
    }
    if (!eventIdsLocaleCookie) {
      Cookie.remove(COOKIE_LOCALE_NAME);
    } else {
      Cookies.set(
        COOKIE_LOCALE_NAME,
        JSON.stringify(eventIdsLocaleCookie),
        cookieOptions
      );
    }
  }
};

/**
 * translate function override that falls back to the key if the original function throws an error
 */
export const translate = (resolveTranslation, key, ...args) => {
  try {
    // Try to translate the key; fall back to the literal string (Ex. Community)
    return resolveTranslation(key, ...args) || key;
  } catch {
    return key;
  }
};

export const checkIfLocaleExists = locale => {
  try {
    return Object.keys(locales).find(
      l => l.toLowerCase() === locale.toLowerCase()
    );
  } catch {
    return null;
  }
};

const switchChineseLocale = locale => {
  switch (locale.toLowerCase()) {
    case 'zh-cht':
      return 'zh-Hant';
    case 'zh-cn':
      return 'zh-Hans';
    default:
      return 'en-US';
  }
};

export const getDefaultLocaleForLanguage = currentLocale => {
  const matchedLocale = checkIfLocaleExists(currentLocale);
  if (matchedLocale) return matchedLocale;
  const language = (currentLocale || defaultLocale).split('-')[0];
  const matchedLanguage = defaultLocales[language.toLowerCase()];
  return matchedLanguage || null;
};

/**
 * This will return the locale to be used for datetime formatting, if current language is same as event's base language
 * for eg current locale = en-US and event culture code is en-GB,
 * then this would return en-GB to be used for date time formatting. In case the current language is different from the event's base language, then
 * the current locale would be used for date time formatting
 * @param cultureCode
 * @param currentLocale
 * @returns {*|T}
 */
export const getLocaleFromCultureCode = (cultureCode, currentLocale) => {
  // Intl.DateTimeFormat does not work with zh-cht
  if (
    currentLocale.toLowerCase() === 'zh-cht' ||
    currentLocale.toLowerCase() === 'zh-cn'
  ) {
    return switchChineseLocale(currentLocale);
  }
  const matchedLocale = getDefaultLocaleForLanguage(cultureCode);
  return matchedLocale === currentLocale ? cultureCode : currentLocale;
};

/**
 * Check if current local is supported in the event locale ( Case when attendee manually alters locale cookie to
 * one of the cvent supported languages but that language is not enabled for the current event
 * @param supportedEventLocales
 * @param locale
 * @param setLocale
 * @param eventId
 * @returns {*|string}
 */
export const validateLocaleCookie = (supportedEventLocales, locale) => {
  const isValidLocale = supportedEventLocales.find(
    supportedLocale =>
      supportedLocale.cultureCode.toLowerCase() === locale?.toLowerCase()
  );
  if (isValidLocale) return locale;
  // current locale not part of the event supported locale, set the locale to event's base locale
  const defaultLocaleObject = supportedEventLocales.find(
    supportedEventLocale => supportedEventLocale.isDefault
  );
  const baseLocale =
    defaultLocaleObject && defaultLocaleObject.cultureCode
      ? defaultLocaleObject.cultureCode
      : defaultLocale;
  return baseLocale;
};
export default locales;
